/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { AppContext } from "../../scripts/context";
import Pagination from "./Pagination";
import RocketIcon from "./RocketIcon";
import DataTableStyle, { DataStyle, StatusStyleTable } from "./style";

const MobileDataTable = ({ transaction, index, boostRow }) => {
  const [openRow, setOpenRow] = useState(false);

  return (
    <div className="data-table-row">
      {index === 0 && (
        <div className="header">
          <p>Staked LP (BULT/TFUEL)</p>
          <p>Unlock Date</p>
          <p>Action</p>
        </div>
      )}
      <div className="values">
        <p>{transaction.stakedLPs}</p>
        <div>
          <StatusStyleTable
            status={transaction.status}
            style={{
              maxWidth: "100px",
            }}
          >
            {transaction.unlockedDate}
          </StatusStyleTable>
        </div>
        <p>
          <RocketIcon
            onClick={() => boostRow(index)}
            style={{
              transform: "rotate(-45.16deg)",
              ...(transaction.isBoost ||
              Date.now() >=
                transaction.lockedDateTimeStamp + transaction.boostingPeriod
                ? {
                    cursor: "default",
                    pointerEvents: "none",
                  }
                : {}),
            }}
            pathStyle={
              transaction.isBoost ||
              Date.now() >=
                transaction.lockedDateTimeStamp + transaction.boostingPeriod
                ? {
                    fill: "#4D62AE",
                  }
                : {}
            }
          />
        </p>
      </div>
      {openRow && (
        <div className="data-table-row-oppend">
          <div>
            <p className="key">Staked LP (BULT/TFUEL)</p>
            <p>{transaction.stakedLPs}</p>
          </div>
          <div>
            <p className="key">Period</p>
            <p>{transaction.stakingPeriodName}</p>
          </div>
          <div>
            <p className="key">Staking Rewards (BULT)</p>
            <p>{transaction.stakingRewards}</p>
          </div>
          <div>
            <p className="key">APR%</p>
            <div>
              <div className="boosting-percentage__APR">
                <span>{transaction.APR + transaction.boostingPercentage}%</span>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 30 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  {transaction.isBoost && (
                    <>
                      <path
                        d="M29.5147 1.76235C29.3058 0.822479 28.5387 0.148017 27.5686 0.0466655C27.4962 0.039374 27.4261 0.0160412 27.3545 0H25.0599C24.542 0.0510403 24.0242 0.0998932 23.507 0.15385C18.7261 0.6504 14.6489 2.5615 11.3119 5.95568C10.8985 6.37567 10.5127 6.82191 10.0993 7.24117C10.0016 7.34033 9.84561 7.42929 9.7098 7.44095C8.37336 7.55689 7.03468 7.65168 5.69748 7.76178C5.04904 7.815 4.50431 8.09646 4.14166 8.61926C3.13354 10.0739 2.1493 11.5446 1.16282 13.0138C1.06283 13.1626 1.01209 13.3427 0.938965 13.5082V14.0551C1.0785 14.4466 1.24267 14.8549 1.64711 15.0226C2.05901 15.1933 2.51196 15.2851 2.95594 15.3617C3.83571 15.5148 4.72145 15.6337 5.60496 15.7678C5.64973 15.7744 5.69226 15.7933 5.71315 15.7999C5.71315 16.0485 5.69674 16.2841 5.71689 16.5167C5.7639 17.0628 5.99522 17.5309 6.39294 17.9188C8.01369 19.5032 9.6322 21.0899 11.2574 22.6699C11.7984 23.1964 12.4528 23.4253 13.2192 23.3072C13.2737 23.2992 13.3289 23.2985 13.4251 23.2912C13.496 23.7206 13.5684 24.1465 13.6371 24.573C13.7482 25.265 13.8594 25.9569 13.9669 26.6496C14.0728 27.3321 14.4586 27.7703 15.1414 27.957C15.1668 27.9635 15.1869 27.9854 15.21 28H15.7697C16.5614 27.5282 17.3598 27.0681 18.1426 26.5825C18.9522 26.0794 19.7432 25.5479 20.5476 25.0367C21.2155 24.6124 21.605 24.032 21.6654 23.2445C21.7617 21.9911 21.8751 20.7391 21.9624 19.4857C21.9781 19.2597 22.0773 19.127 22.2393 18.9907C24.2652 17.291 26.0053 15.3573 27.2709 13.0459C28.3984 10.9846 29.055 8.77383 29.3692 6.46317C29.461 5.78797 29.5199 5.10768 29.5938 4.4303V2.18671C29.5677 2.04526 29.546 1.90235 29.5147 1.76235ZM6.16759 14.1899C5.0259 14.0179 3.89168 13.8465 2.72313 13.6708C2.89849 13.4105 3.05071 13.183 3.20443 12.9562C3.92899 11.8851 4.64833 10.8096 5.38483 9.74652C5.48556 9.60069 5.66391 9.43007 5.82285 9.41257C6.72799 9.31122 7.63835 9.25361 8.60841 9.17559C7.54433 10.7549 6.71754 12.386 6.16759 14.1907V14.1899ZM12.8938 21.6841C12.7625 21.7104 12.5603 21.6083 12.4528 21.5048C10.8224 19.9276 9.1994 18.3424 7.58761 16.7478C7.47344 16.6348 7.37718 16.408 7.41001 16.2644C7.58686 15.4842 7.80699 14.7135 8.01444 13.9398C8.02115 13.9158 8.04578 13.8961 8.04876 13.8932C10.4911 16.2804 12.9334 18.6684 15.4332 21.1117C14.575 21.3101 13.7385 21.5157 12.8953 21.6849L12.8938 21.6841ZM20.0589 22.3236C20.0365 22.605 20.029 22.8894 19.9768 23.1665C19.9499 23.3072 19.8745 23.4829 19.7619 23.5573C18.3956 24.4593 17.0188 25.3452 15.607 26.2595C15.5123 25.6813 15.422 25.1388 15.3347 24.5956C15.2556 24.1012 15.1809 23.6054 15.1004 23.1111C15.0772 22.9703 15.0884 22.8807 15.2615 22.8296C16.9681 22.3258 18.5478 21.5587 20.0387 20.6101C20.0753 20.5868 20.1163 20.5685 20.1954 20.527C20.1477 21.1518 20.1044 21.7381 20.0589 22.3243V22.3236ZM27.8969 3.69386C27.8305 6.7942 27.2209 9.77423 25.6576 12.5042C24.1182 15.1911 21.955 17.3326 19.3671 19.0665C18.7082 19.5076 17.9911 19.8649 17.3054 20.2681C17.1546 20.3563 17.0658 20.3235 16.9494 20.2098C14.2758 17.5914 11.5992 14.976 8.92107 12.3627C8.81213 12.2562 8.75989 12.1768 8.84645 12.0171C10.8381 8.35822 13.6251 5.45767 17.4069 3.5371C19.4716 2.48858 21.705 1.94901 24.0167 1.75652C25.0547 1.67048 26.1008 1.66975 27.144 1.66319C27.7208 1.65954 27.8723 1.82579 27.894 2.38213C27.9111 2.81889 27.8977 3.25637 27.8977 3.69386H27.8969Z"
                        fill="#3C82C2"
                      />
                      <path
                        d="M7.7291 22.5007C7.92983 22.209 7.94401 21.902 7.75895 21.6016C7.57837 21.3085 7.29034 21.159 6.95529 21.2298C6.74263 21.2742 6.51877 21.3982 6.36356 21.5491C4.72788 23.1299 3.10266 24.7209 1.48117 26.3148C1.28193 26.511 1.12001 26.7436 0.940918 26.9594V27.3969C1.07225 27.6696 1.27895 27.8687 1.55653 27.9984H2.00425C2.17886 27.8687 2.37138 27.7564 2.52585 27.6069C4.19659 25.9831 5.86136 24.3534 7.52688 22.7253C7.59926 22.6545 7.67314 22.5831 7.72985 22.5007H7.7291Z"
                        fill="#FF95A3"
                      />
                      <path
                        d="M2.34728 22.861C3.29943 21.9626 4.2374 21.049 5.15597 20.1179C5.60295 19.6644 5.34999 18.9257 4.7284 18.7799C4.38739 18.6997 4.11279 18.8266 3.87251 19.0636C3.05169 19.8714 2.21893 20.6684 1.40706 21.4851C1.21827 21.6746 1.09366 21.9247 0.939941 22.1471V22.3659C0.96382 22.4242 0.986952 22.4833 1.01158 22.5416C1.23768 23.0826 1.91746 23.2664 2.34728 22.861Z"
                        fill="#FF95A3"
                      />
                      <path
                        d="M8.9815 23.8956C8.05099 24.7902 7.12495 25.6893 6.21384 26.6029C5.77732 27.0411 5.96461 27.7207 6.55187 27.938C6.60336 27.9569 6.65336 27.9788 6.7041 27.9992H6.92796C7.08914 27.9132 7.28091 27.857 7.40702 27.736C8.33231 26.8494 9.25013 25.9554 10.1583 25.052C10.4955 24.7166 10.4739 24.2113 10.1441 23.8978C9.82471 23.5944 9.31058 23.5791 8.98075 23.8963L8.9815 23.8956Z"
                        fill="#FF95A3"
                      />
                      <path
                        d="M20.5679 4.71631C18.2517 4.71777 16.3757 6.55376 16.3765 8.81922C16.3765 11.0927 18.242 12.9134 20.5679 12.9134C22.8893 12.9134 24.7682 11.0818 24.7682 8.81849C24.7682 6.56105 22.8781 4.71485 20.5671 4.71631H20.5679ZM20.5403 11.2728C19.1523 11.2611 18.0502 10.1667 18.0562 8.80537C18.0621 7.4528 19.1867 6.35762 20.5686 6.35762C21.9558 6.35762 23.1005 7.48197 23.0893 8.83308C23.0781 10.1966 21.9416 11.2845 20.5403 11.2728Z"
                        fill="#3C82C2"
                      />
                    </>
                  )}
                </svg>
              </div>
            </div>
          </div>
          <div>
            <p className="key">Unlock Date</p>
            <p>{transaction.unlockedDate}</p>
          </div>
          <div>
            <p className="key">Status</p>
            <div>
              <StatusStyleTable
                style={{ width: "fit-content", padding: "2px 10px" }}
                status={transaction.status}
              >
                {transaction.status}
              </StatusStyleTable>
            </div>
          </div>
        </div>
      )}
      <div className="more-information" onClick={() => setOpenRow(!openRow)}>
        <span>{openRow ? "Less" : "More"} Information</span>
        <svg
          width="11"
          height="7"
          viewBox="0 0 11 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            transform: openRow ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease-in-out",
          }}
        >
          <path
            d="M1.62317 0.113281L5.45129 3.8348L9.27942 0.113281L10.4513 1.25252L5.45129 6.11328L0.451294 1.25252L1.62317 0.113281Z"
            fill="#6D7D97"
          />
        </svg>
      </div>
    </div>
  );
};

export default function DataTable() {
  const {
    state,
    state: {
      contracts: {
        nft: {
          data: { lockedNFT },
        },
        staking: {
          data: { transactionsList },
        },
      },
    },
    getWeb3,
  } = useContext(AppContext);
  const [paginationData, setPaginationDatas] = useState({
    page: 1,
    rowsPerPage: localStorage.rowsPerPage || 5,
    totalRows: 1,
    data: [],
  });
  const setPaginationData = (data) =>
    setPaginationDatas({ ...paginationData, ...data });

  useEffect(() => {
    const numPages = Math.ceil(
      transactionsList.length / paginationData.rowsPerPage
    );

    setPaginationData({
      totalRows: numPages || 1,
      data: [
        ...transactionsList.slice(
          (paginationData.page - 1) * paginationData.rowsPerPage,
          paginationData.page * paginationData.rowsPerPage
        ),
      ],
    });
  }, [paginationData.rowsPerPage, paginationData.page, transactionsList]);

  const boostRow = async (index) => {
    if (!lockedNFT?.tokenID) return toast.error("You must Lock NFT");

    const result = await state.contracts.staking.contract.boostStaking(
      index,
      process.env.REACT_APP_CONTRACT_ADDRESS
    );

    toast.promise(
      result.wait().then(() => {
        getWeb3();
      }),
      {
        loading: "Loading...",
        success: "boosted",
        error: (error) => error.message,
      }
    );
  };

  return (
    <>
      <DataTableStyle>
        <table
          cellSpacing="0"
          cellPadding="0"
          className="table dt-responsive custom-table nowrap"
        >
          <thead>
            <tr>
              <th>Staked LP (BULT/TFUEL)</th>
              <th>Period</th>
              <th className="text-center">Staking Rewards (BULT)</th>
              <th>APR%</th>
              <th>Unlock Date</th>
              <th className="text-center">Status</th>
              <th className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginationData.data.length > 0 ? (
              paginationData.data.map((transaction, index) => (
                <tr key={index}>
                  <td>{transaction.stakedLPs}</td>
                  <td>{transaction.stakingPeriodName}</td>
                  <td className="text-center">{transaction.stakingRewards}</td>
                  <td>
                    <div className="boosting-percentage__APR">
                      <span>
                        {transaction.APR + transaction.boostingPercentage}%
                      </span>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 30 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        {transaction.isBoost && (
                          <>
                            <path
                              d="M29.5147 1.76235C29.3058 0.822479 28.5387 0.148017 27.5686 0.0466655C27.4962 0.039374 27.4261 0.0160412 27.3545 0H25.0599C24.542 0.0510403 24.0242 0.0998932 23.507 0.15385C18.7261 0.6504 14.6489 2.5615 11.3119 5.95568C10.8985 6.37567 10.5127 6.82191 10.0993 7.24117C10.0016 7.34033 9.84561 7.42929 9.7098 7.44095C8.37336 7.55689 7.03468 7.65168 5.69748 7.76178C5.04904 7.815 4.50431 8.09646 4.14166 8.61926C3.13354 10.0739 2.1493 11.5446 1.16282 13.0138C1.06283 13.1626 1.01209 13.3427 0.938965 13.5082V14.0551C1.0785 14.4466 1.24267 14.8549 1.64711 15.0226C2.05901 15.1933 2.51196 15.2851 2.95594 15.3617C3.83571 15.5148 4.72145 15.6337 5.60496 15.7678C5.64973 15.7744 5.69226 15.7933 5.71315 15.7999C5.71315 16.0485 5.69674 16.2841 5.71689 16.5167C5.7639 17.0628 5.99522 17.5309 6.39294 17.9188C8.01369 19.5032 9.6322 21.0899 11.2574 22.6699C11.7984 23.1964 12.4528 23.4253 13.2192 23.3072C13.2737 23.2992 13.3289 23.2985 13.4251 23.2912C13.496 23.7206 13.5684 24.1465 13.6371 24.573C13.7482 25.265 13.8594 25.9569 13.9669 26.6496C14.0728 27.3321 14.4586 27.7703 15.1414 27.957C15.1668 27.9635 15.1869 27.9854 15.21 28H15.7697C16.5614 27.5282 17.3598 27.0681 18.1426 26.5825C18.9522 26.0794 19.7432 25.5479 20.5476 25.0367C21.2155 24.6124 21.605 24.032 21.6654 23.2445C21.7617 21.9911 21.8751 20.7391 21.9624 19.4857C21.9781 19.2597 22.0773 19.127 22.2393 18.9907C24.2652 17.291 26.0053 15.3573 27.2709 13.0459C28.3984 10.9846 29.055 8.77383 29.3692 6.46317C29.461 5.78797 29.5199 5.10768 29.5938 4.4303V2.18671C29.5677 2.04526 29.546 1.90235 29.5147 1.76235ZM6.16759 14.1899C5.0259 14.0179 3.89168 13.8465 2.72313 13.6708C2.89849 13.4105 3.05071 13.183 3.20443 12.9562C3.92899 11.8851 4.64833 10.8096 5.38483 9.74652C5.48556 9.60069 5.66391 9.43007 5.82285 9.41257C6.72799 9.31122 7.63835 9.25361 8.60841 9.17559C7.54433 10.7549 6.71754 12.386 6.16759 14.1907V14.1899ZM12.8938 21.6841C12.7625 21.7104 12.5603 21.6083 12.4528 21.5048C10.8224 19.9276 9.1994 18.3424 7.58761 16.7478C7.47344 16.6348 7.37718 16.408 7.41001 16.2644C7.58686 15.4842 7.80699 14.7135 8.01444 13.9398C8.02115 13.9158 8.04578 13.8961 8.04876 13.8932C10.4911 16.2804 12.9334 18.6684 15.4332 21.1117C14.575 21.3101 13.7385 21.5157 12.8953 21.6849L12.8938 21.6841ZM20.0589 22.3236C20.0365 22.605 20.029 22.8894 19.9768 23.1665C19.9499 23.3072 19.8745 23.4829 19.7619 23.5573C18.3956 24.4593 17.0188 25.3452 15.607 26.2595C15.5123 25.6813 15.422 25.1388 15.3347 24.5956C15.2556 24.1012 15.1809 23.6054 15.1004 23.1111C15.0772 22.9703 15.0884 22.8807 15.2615 22.8296C16.9681 22.3258 18.5478 21.5587 20.0387 20.6101C20.0753 20.5868 20.1163 20.5685 20.1954 20.527C20.1477 21.1518 20.1044 21.7381 20.0589 22.3243V22.3236ZM27.8969 3.69386C27.8305 6.7942 27.2209 9.77423 25.6576 12.5042C24.1182 15.1911 21.955 17.3326 19.3671 19.0665C18.7082 19.5076 17.9911 19.8649 17.3054 20.2681C17.1546 20.3563 17.0658 20.3235 16.9494 20.2098C14.2758 17.5914 11.5992 14.976 8.92107 12.3627C8.81213 12.2562 8.75989 12.1768 8.84645 12.0171C10.8381 8.35822 13.6251 5.45767 17.4069 3.5371C19.4716 2.48858 21.705 1.94901 24.0167 1.75652C25.0547 1.67048 26.1008 1.66975 27.144 1.66319C27.7208 1.65954 27.8723 1.82579 27.894 2.38213C27.9111 2.81889 27.8977 3.25637 27.8977 3.69386H27.8969Z"
                              fill="#3C82C2"
                            />
                            <path
                              d="M7.7291 22.5007C7.92983 22.209 7.94401 21.902 7.75895 21.6016C7.57837 21.3085 7.29034 21.159 6.95529 21.2298C6.74263 21.2742 6.51877 21.3982 6.36356 21.5491C4.72788 23.1299 3.10266 24.7209 1.48117 26.3148C1.28193 26.511 1.12001 26.7436 0.940918 26.9594V27.3969C1.07225 27.6696 1.27895 27.8687 1.55653 27.9984H2.00425C2.17886 27.8687 2.37138 27.7564 2.52585 27.6069C4.19659 25.9831 5.86136 24.3534 7.52688 22.7253C7.59926 22.6545 7.67314 22.5831 7.72985 22.5007H7.7291Z"
                              fill="#FF95A3"
                            />
                            <path
                              d="M2.34728 22.861C3.29943 21.9626 4.2374 21.049 5.15597 20.1179C5.60295 19.6644 5.34999 18.9257 4.7284 18.7799C4.38739 18.6997 4.11279 18.8266 3.87251 19.0636C3.05169 19.8714 2.21893 20.6684 1.40706 21.4851C1.21827 21.6746 1.09366 21.9247 0.939941 22.1471V22.3659C0.96382 22.4242 0.986952 22.4833 1.01158 22.5416C1.23768 23.0826 1.91746 23.2664 2.34728 22.861Z"
                              fill="#FF95A3"
                            />
                            <path
                              d="M8.9815 23.8956C8.05099 24.7902 7.12495 25.6893 6.21384 26.6029C5.77732 27.0411 5.96461 27.7207 6.55187 27.938C6.60336 27.9569 6.65336 27.9788 6.7041 27.9992H6.92796C7.08914 27.9132 7.28091 27.857 7.40702 27.736C8.33231 26.8494 9.25013 25.9554 10.1583 25.052C10.4955 24.7166 10.4739 24.2113 10.1441 23.8978C9.82471 23.5944 9.31058 23.5791 8.98075 23.8963L8.9815 23.8956Z"
                              fill="#FF95A3"
                            />
                            <path
                              d="M20.5679 4.71631C18.2517 4.71777 16.3757 6.55376 16.3765 8.81922C16.3765 11.0927 18.242 12.9134 20.5679 12.9134C22.8893 12.9134 24.7682 11.0818 24.7682 8.81849C24.7682 6.56105 22.8781 4.71485 20.5671 4.71631H20.5679ZM20.5403 11.2728C19.1523 11.2611 18.0502 10.1667 18.0562 8.80537C18.0621 7.4528 19.1867 6.35762 20.5686 6.35762C21.9558 6.35762 23.1005 7.48197 23.0893 8.83308C23.0781 10.1966 21.9416 11.2845 20.5403 11.2728Z"
                              fill="#3C82C2"
                            />
                          </>
                        )}
                      </svg>
                    </div>
                  </td>
                  <td>{transaction.unlockedDate}</td>
                  <td>
                    <StatusStyleTable status={transaction.status}>
                      {transaction.status}
                    </StatusStyleTable>
                  </td>
                  <td className="text-center">
                    <RocketIcon
                      onClick={() => boostRow(transaction.stakeID)}
                      style={{
                        transform: "rotate(-45.16deg)",
                        marginTop: "0.5rem",
                        ...(transaction.isBoost ||
                        Date.now() >=
                          transaction.lockedDateTimeStamp +
                            transaction.boostingPeriod
                          ? {
                              cursor: "default",
                              pointerEvents: "none",
                            }
                          : {
                              cursor: "pointer",
                              fill: "#17AE7F",
                            }),
                      }}
                      pathStyle={
                        transaction.isBoost ||
                        Date.now() >=
                          transaction.lockedDateTimeStamp +
                            transaction.boostingPeriod
                          ? {
                              fill: "#4D62AE",
                            }
                          : { fill: "#17AE7F" }
                      }
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No transactions
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Pagination
          paginationData={paginationData}
          setPaginationData={setPaginationData}
        />
      </DataTableStyle>

      <DataStyle>
        {paginationData.data.map((transaction, index) => (
          <MobileDataTable
            key={index}
            transaction={transaction}
            index={index}
          />
        ))}
        <Pagination
          paginationData={paginationData}
          setPaginationData={setPaginationData}
        />
      </DataStyle>
    </>
  );
}
